import { render, staticRenderFns } from "./detail_config_search_arg.vue?vue&type=template&id=1b3dfb54"
import script from "./detail_config_search_arg.vue?vue&type=script&lang=js"
export * from "./detail_config_search_arg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b3dfb54')) {
      api.createRecord('1b3dfb54', component.options)
    } else {
      api.reload('1b3dfb54', component.options)
    }
    module.hot.accept("./detail_config_search_arg.vue?vue&type=template&id=1b3dfb54", function () {
      api.rerender('1b3dfb54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/customform/detail_config_search_arg.vue"
export default component.exports